import { Configurable } from "@crystal/config";
const mfSiteConfig = Configurable.props({
  isSelectAllEnabled: true
});
const KR = {
  KR: mfSiteConfig
};
export {
  KR
};
//# sourceMappingURL=KR.js.map
